export function processPaginatorResults(current, limit, payload) {
    let paginator = {
        count: payload.count,
        limit: limit,
        current: current,
        next: null,
        previous: null,
        allPages: 0
    }

    if (payload.count > 0) {
        paginator.allPages = Math.ceil(payload.count / limit);
    } else {
        paginator.allPages = 1
    }

    if (payload.next) {
        paginator.next = current + 1;
    }
    if (payload.previous) {
        paginator.previous = current - 1;
    }
    return paginator
}

export function toFormAnyBackendLink(path) {
    return `${process.env.VUE_APP_BACKEND_URL}${path}`
}

export function copyTextToClipboard(value) {
  navigator.clipboard.writeText(value)
}

export function parseDateFromStr(date) {
  const [day, month, year] = date.split('.')
  return (new Date(new Date(`${month}.${day}.${year}`) - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10)
}

export function formatDateStr (date) {
  if (!date) return null

  const [year, month, day] = date.split('-')
  return `${day}.${month}.${year}`
}


export function parseDateTimeStrToStr(value) {
    if (value) {
        const [datePart, timePart] = value.split(' ');
        const [day, month, year] = datePart.split('.');
        const [hours, minutes] = timePart.split(':');
        return {day, month, year, hours, minutes}
    } else {
        return {day: '', month: '', year: '', hours: '', minutes: ''}
    }
}


export function convertUTCToLocalTime(utcTime) {
  const date = new Date(utcTime);
    return date.toLocaleString('uk-UA', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
  });
}


export function formatAmountStr (value) {
    let number = Number(value)
    return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
}

export function getLocalStorageValue(key, defaultValue=null) {
    let scopeValue = localStorage.getItem(key)
    return scopeValue !== null ? JSON.parse(scopeValue) : defaultValue
}

export function setLocalStorageValue(key, value) {
    localStorage.setItem(key, JSON.stringify(value))
    return value
}
